import React, { useState, useEffect, useRef } from "react";
import style from './proReportChart.module.scss';
import toPersianNumber from '../../../helpers/actions/toPersianNumber'
import { Chart } from "chart.js";

let myLineChart;
Chart.defaults.global.defaultFontFamily = "IRANSans";

const ProReportChart = (props) => {

    const refrence = useRef()

    useEffect(() => {
        if (typeof refrence.current != 'undefined') {
            const myChartRef = refrence.current.getContext("2d");
            window[myLineChart + props.tag] = new Chart(myChartRef, {
                type: "bar",
                data: {
                    labels: props.data.map(el => el.label),
                    datasets: [
                        {
                            label: "محصول",
                            data: props.data.map(el => el.data),
                            fill: false,
                            borderColor: "#192a56",
                            backgroundColor: "#192a56",
                        },
                    ]
                },
                gridLines: {
                    display: false
                },
                options: {
                    responsive: true,
                    layout: {
                        padding: {
                            top: 5
                        }
                    },
                    legend: {
                        display: false,
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: false
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                callback: function (value, index, values) {
                                    return (value % 1 == 0 ? toPersianNumber(value) : '')
                                }
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, chart) {
                                let string = `${toPersianNumber(tooltipItem.value)}`
                                return string
                            }
                        }
                    }
                },
            });
        }
    }, [props]);
    return (
        <div className={style.wrapper}>
            <div className={style.blueBox}>
                <canvas
                    ref={refrence}
                    style={{ boxSizing: "border-box", width: "100%" }}
                    height="200"
                >
                </canvas>
            </div>
        </div>
    )
}
export default ProReportChart

